import React, { useEffect, useState } from "react";
import AddCharacterForm from "./AddCharacterForm";
import { Button } from "../components/ui/button";
import Menu from "./Menu";
import axios from "axios";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

interface Character {
    id: string;
    name: string;
    link: string;
    imageUrl: string;
}

const CharacterList: React.FC = () => {
    const [characters, setCharacters] = useState<Character[]>([]);
    const [showForm, setShowForm] = useState(false);
    const { user } = useAuth();
    const type = "characters";
    const userId = user?.uid ?? "";

    useEffect(() => {
        const fetchCharacters = async () => {
            try {
                const response = await axios.get(api.getAll(type, userId));

                if (Array.isArray(response.data)) {
                    const parsed = response.data.map((char: any) => ({
                        id: char.id,
                        name: char.identity?.name ?? "Unnamed",
                        link: char.link ?? "#",
                        imageUrl: char.imageUrl ?? "https://via.placeholder.com/150x200?text=No+Image"
                    }));
                    setCharacters(parsed);
                } else {
                    setCharacters([]);
                }
            } catch (error) {
                console.error("Error fetching characters:", error);
            }
        };

        if (userId) fetchCharacters();
    }, [userId]);

    return (
        <div className="min-h-screen bg-[#E4F1FF] text-[#333333] p-6">
            <div className="flex justify-between items-center mb-6">
                <h1 className="text-3xl font-bold">Character List</h1>
                <Menu openAddCharacterForm={() => setShowForm(true)} />
            </div>

            {showForm && <AddCharacterForm onClose={() => setShowForm(false)} />}

            <ul className="space-y-6">
                {characters.map((character) => (
                    <li key={character.id} className="bg-white p-4 rounded shadow flex gap-4 items-start">
                        <img
                            src={character.imageUrl}
                            alt={character.name}
                            className="w-24 h-32 object-cover rounded"
                        />
                        <div>
                            <a
                                href={character.link}
                                className="text-2xl text-[#333333] hover:underline font-semibold"
                            >
                                {character.name}
                            </a>
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CharacterList;
